import { useBrowserTabNotification } from 'services/notifications/hooks/useBrowserTabNotification';
import { SearchConversationsItem } from 'modules/conversations/types';
import { useEffect } from 'react';

export const useCampaignNeedsReviewNotification = ({
  conversations
}: {
  conversations: SearchConversationsItem[];
}) => {
  const { setNotificationTo, clearNotification } = useBrowserTabNotification();

  useEffect(() => {
    const conversationNeedsReview = conversations.filter(
      (conversation) => conversation.needsReview
    );

    setNotificationTo(conversationNeedsReview.length);

    return () => {
      clearNotification();
    };
  }, [JSON.stringify(conversations)]);
};
